import Vue from 'vue'
import App from './App.vue'
import Vuetify from './plugins/vuetify'
import VueCarousel from 'vue-carousel'
import VueGtag from 'vue-gtag'
import { ValidationProvider, ValidationObserver, extend, setInteractionMode } from 'vee-validate'
import { required, min, max, email, confirmed, alpha_spaces, numeric, length, alpha_num, alpha, alpha_dash, regex} from 'vee-validate/dist/rules'
import Editor from '@tinymce/tinymce-vue'
import router from './router'
import store from './store'
import './assets/styles/main.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

import draggable from 'vuedraggable'

import axios from 'axios'

Vue.config.productionTip = false
axios.defaults.withCredentials = true

setInteractionMode('eager')

extend('max', {
  ...max,
  message: '{_field_} may not be greater than {length} characters'
})

extend('min', {
  ...min,
  message: '{_field_} may not be less than {length} characters'
})


extend('required', {
  ...required,
  message: 'This field is required'
})

extend('email', {
  ...email,
  message: 'Please enter a valid e-mail'
})

extend('confirmed', {
  ...confirmed,
  message: 'This field does not match'
})

extend('alpha', {
  ...alpha,
  message: 'The contents of this field must be alphabetical.'
})

extend('alpha_num', {
  ...alpha_num,
  message: 'The contents of this field must be alpha-numeric.'
})

extend('alpha_spaces', {
  ...alpha_spaces,
  message: 'This field can only contain alphabetical characters and spaces.'
})

extend('alpha_dash', {
  ...alpha_dash,
  message: 'This field can only contain alphabetical characters, numbers, dashes, or underscores.'
})

extend('length', {
  ...length,
  message: 'Please make sure your number is 10 digits (include area code)'
})

extend('numeric', {
  ...numeric,
  message: 'Please enter a valid number (numbers only, no special characters)'
})

extend('decimal', {
  validate: (value, args : any) => {
      if (value === null || value === undefined || value === "" || value=="-") {
          return {
              valid: false
          }
      }
      const decimals = args[0] ?? "*"
      const separator = args[1] ?? "."
      if (!decimals) {
          return {
              valid: /^-?\d*$/.test(value)
          }
      }
      const regexPart = decimals === '*' ? "+" : `{1,${decimals}}`
      const regex = new RegExp(`^[-+]?\\d*(\\${separator}\\d${regexPart})?([eE]{1}[-]?\\d+)?$`)
      return {
          valid: regex.test(value)
      }
  },
  message: 'The {_field_} field must contain only decimal values'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.component('draggable', draggable)
Vue.component('editor', Editor)
Vue.use(VueCarousel)
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_ANALYTICS_VIEW_ID }
}, router)

export const bus = new Vue()

Vue.mixin({
  methods: {
    cloudinaryUrl: function(publicId: string, opts: string = "", make: string) {
      return (
          "https://res.cloudinary.com/shopaccessories/image/upload/" + opts + make + "/products/" + publicId
      ) 
    },
    cloudinaryDealerUrl: function(publicId: string, opts: string = "", make: string, dealerCode: string) {
      return (
        "https://res.cloudinary.com/shopaccessories/image/upload/" + opts + make + "/dealers/" + dealerCode + "/" + publicId
      )
    },
    cloudinaryModel: function (manufacturer: string, modelId: string, opts: string = "") {
      return (
        "https://res.cloudinary.com/shopdesk-images/image/upload/" + opts + "images/manufacturers/" + manufacturer + "/vehicles/" + modelId + "/vehicle.png" 
      )
    },
    cloudinaryTrim: function (manufacturer: string, modelId: string, trimId: string, opts: string = "") {
      return (
        "https://res.cloudinary.com/shopdesk-images/image/upload/" + opts + "images/manufacturers/" + manufacturer + "/vehicles/" + modelId + "/trims/" + trimId + "/vehicle.png" 
      )
    },
    currencyFormatter: function(value: number) {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD"
        }).format(value)
    }
  }
})

store.dispatch('auth/me').then(() => {
  new Vue({
    vuetify: Vuetify,
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
